import { useSelector } from "react-redux";

export const useAdminSelector = () => {
  return useSelector((state) => state.admin)
}

